<template>
<main-layout :selectedMenu="'activity'">
  <div class='banner-wrap' v-if="isSHow">
    <div class="con">
      <img class='banner-activity' :src="data.thumb | imageUrl('', 480, 640)" alt="">
      <div class="info">
        <p class="title">{{data.title}}</p>
        <p class="user">
          <router-link :to="'/peopleCenter/' + data.userId" target="_blank">
            <img :src="data.avatar | imageUrl('/static/profile_img_default.png',40,40)">{{data.nickname}}
          </router-link>
        </p>
        <p class="time">{{dateFormatter(data.holdStartTime)}} {{$t('global.至')}} {{dateFormatter(data.holdEndTime)}}</p>
        <p class="address">{{data.cityName}} {{data.place}}</p>
        <div class="tags">
          <span v-for="item in data.tags">{{item}}</span>
        </div>
        <div class="price-wrap">
          <span
            class="price"
            :class="{'end': Date.now() > data.holdEndTime}"
            v-if="data.joinType === 1"
          >
            <i>{{data.price }}</i>
          </span>
          <span
            class="price"
            :class="{'end': Date.now() > data.holdEndTime}"
            v-if="data.category === 2 && data.joinType !== 1"
          >
            <i>{{$t('global.免费')}}</i>
          </span>
          <!-- <span class="fav">
            <i v-if="data.collectCount > 0">{{data.collectCount}}{{$t('global.人感兴趣')}}</i>
          </span> -->
        </div>
        <p class="btn-wrap">
          <span target="_blank"
            class="linkBut"
            v-if="data.joinType !== 3 && Date.now() <= data.holdEndTime"
            @click="gotoLink(data)"
            :disabled="Date.now() > data.holdEndTime || (data.joinType<2 && !data.purchaseLink)"
          >{{data.joinType == 1 ? $t('global.购票链接') : data.joinType == 2 ? $t('global.立即报名') : $t('global.报名链接')}}</span>
          <span class="disabled" v-if="Date.now() > data.holdEndTime">{{$t('global.已结束')}}</span>
        </p>
      </div>
    </div>
  </div>
  <div class="container-wrap">
    <section class='container'>
      <main class='left'>
        <slot></slot>
      </main>
      <aside>
        <slot name='right-aside'></slot>
      </aside>
    </section>
  </div>
</main-layout>
</template>

<script>
  import MainLayout from "@/layouts/MainLayout";
  import tools from "@/util/tools";

  export default {
    name: 'ActivityLayout',
    metaInfo(){
      return this.metaInfoData;
    },
    components: {
      MainLayout,
    },
    data () {
      return {
        isSHow: false,
        data: {},
        metaInfoData:{},
        category: ["", this.$t('global.线上活动'), this.$t('global.线下活动'), this.$t('global.竞赛')],
      }
    },
    props: {
      selectedMenu: String,
      banner: String
    },
    created () {
      this.$http
        .get('/api/activity/detail', {
          params: {
            activityId: this.$route.params.id
          }
        })
        .then(data => {
          this.data = data.data;
          this.data.type = this.category[this.data.category];
          this.data.tags = eval(this.data.tags);
          this.metaInfoData = {
            title: `${this.data.title} - MANA - ${this.$t('global.全球新媒体艺术平台')} - ${this.$t('global.艺术')}/${this.$t('global.设计')}/${this.$t('global.科技')}/${this.$t('global.跨界创新')}`,
            meta: [{name: 'keyWords',content: this.data.title},
              {name:'description',content:this.data.title}
            ],
            link: [{                 // set link
              rel: this.title,
              href: `https://www.manamana.net/activity/${this.data.activityId}/detail`
            }]
          }
          this.isSHow = true;
        })
    },
    methods: {
      dateFormatter: tools.dateFormatter,
      gotoLink(data) {
        if (data.joinType == 2) {
          window.open("https://m.manamana.net/ticket/get/" + this.$route.params.id, "_blank");
        } else {
          window.open(data.purchaseLink,"_blank")
        }
      }
    }
  }
</script>

<style lang="stylus" scoped>
.banner-wrap
  justify-content center
  align-items center
  overflow hidden
  background #fff
.con
  position relative
  width 1160px
  height 400px
  margin 20px auto 0
  padding 40px 0 0 300px
  border 1px solid #eee
  box-shadow 0 0 20px 0 #eee
  border-radius 14px
  box-sizing border-box
  font-size 14px
.banner-activity
    position absolute
    top 40px
    left 40px
    width 240px
    height 320px
    margin 0 auto
    border-radius 8px

.info
  position relative
  height 320px

  .title
    font-size 26px
    font-weight bold

  .status
    margin-top 15px;
    .status-wrap
          margin-right 10px
          padding 0 5px
          border 1px solid #ccc
          color #aaa
          border-radius 3px
        .status-green
          color #3664ED
          border-color #7C9AF3
          font-weight bold
  .tags
    margin-top 15px

    span
      margin-right 10px
      padding 0 5px
      color #aaa
      background hsla(0,0%,76.5%,.1)
      border-radius 4px

  .time
    margin-top 15px
    color #999

  .address
    margin-top 15px
    color #999

  .user
    margin-top 10px
    a
      color #333
    img
      width 18px
      height 18px
      margin-right 5px
      border-radius 50%
      vertical-align middle

  .price-wrap
    margin-top 15px

    .price
      margin-right 20px
      i
        font-weight bold
        color #f55f54
        font-size 24px
    .end
      i
        color #999

    .fav
      color #999
  .type
      margin-top 10px
      font-size 14px

  .btn-wrap
    position absolute
    right 0
    bottom 0
    left 0

    .linkBut
      display inline-block
      padding 10px 20px
      background #3664ed
      color #fff
      font-size 16px
      font-weight bold
      border-radius 4px
      cursor pointer
    .disabled
      display inline-block
      padding 10px 20px
      color #c3c3c3
      background #e7e7e7
      font-size 16px
      font-weight bold
      border-radius 4px
      cursor pointer
.container-wrap
  background #fff
.container
    display flex
    width 1160px
    padding-top 40px
    background #fff
.left
    width 757px
    border 1px solid #eee
    box-shadow 0 0 20px 0 #eee
    border-radius 14px
</style>



// WEBPACK FOOTER //
// src/layouts/ActivityLayout.vue